export default "__VITE_ASSET__zcOLhTAF__"